exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".rule-input[data-v-2cf0bf0c]  .el-input__inner{border:0}\n", ""]);

// exports
